import React from "react";
import images from "../data/image-gallery-data";

const Genuine = () => {
    const processedImages = images.filter(item => item.manufacturer === "Genuine");
  return (
    <div className="row">
      <React.Fragment>
        {processedImages.map((item) => {
          return (
            <React.Fragment key={item.id}>
              <div className="col-lg-4 col-md-14 mb-6 mb-lg-0">
                <figure>
                  <img
                    src={item.location}
                    className="w-100 shadow-1-strong rounded mb-4"
                    alt={item.title ? `${item.title} by ${item.manufacturer}` : `${item.manufacturer} medical imaging product`}
                  />
                  <figcaption className="caption-text">{item.title} </figcaption>
                </figure>
              </div>
            </React.Fragment>
          );
        })}
      </React.Fragment>
    </div>
  );
};

export default Genuine;
